import { render, staticRenderFns } from "./LaboratoryConfigurationInfo.vue?vue&type=template&id=19e046e4&scoped=true&"
import script from "./LaboratoryConfigurationInfo.vue?vue&type=script&lang=js&"
export * from "./LaboratoryConfigurationInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e046e4",
  null
  
)

export default component.exports